import { atomWithStorage } from 'jotai/utils';

const areMessagesAscendingAtom = atomWithStorage('areMessagesAscending', true);
const areMessagesExpandedAtom = atomWithStorage('areMessagesExpanded', false);

export { areMessagesAscendingAtom, areMessagesExpandedAtom };
